<div class="upload-type-modal modal-body-pd">
    <mapfre-modal [modalOptions]="uploadTypeModalOptions" [hideModal]="hideModal"
        (hideModalOutput)="hideModalAction()" 
        (modalHide)="hideOnClick($event)"
        >
        <div class="modal-body" [ngClass]="{'modal-padded-md modal-body-ma':!isAcmic }">
            <div class="upload-modal-title">
                <h1 class="upload-type-modal-title"> {{ 'What would you like to upload?' | translate }}</h1>
            </div>
            <div class="upload-type-sec">
                <div class="upload-type-card upload-card-height">
                    <div class="upload-type-card-inner" style="justify-content: space-between;" (click)="openUploadDocPage()">
                        <div>
                            <div class="upload-type-card-title">Policy or billing documents</div>
                            <div class="upload-type-card-inner-content">
                                Related to:
                                <ul>
                                    <li>Bank statement</li>
                                    <li>Indemnity forms</li>
                                    <li>Proof of identity, address
                                    <br>and ownership</li>
                                </ul>
                            </div>
                        </div>
                        <img alt="right arrow icon" [src]="imgPath">
                    </div>
                </div>
                <div class="upload-type-card claim-card-doc-type">
                    <div class="upload-type-card-inner" (click)="openClaimUploadDocPage()">
                        <div class="claim-doc-type">
                            <div class="upload-type-card-title">Claim documents</div>
                            <div>
                                Related to:
                                <ul>
                                    <li>Active claim process</li>
                                    <li>Forms</li>
                                    <li>Incident photos</li>
                                </ul>
                            </div>
                        </div>
                        <img alt="right arrow icon" [src]="imgPath">
                    </div>
                </div>
            </div>
            
        </div>
    </mapfre-modal>
</div>